
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platnosc/blad-dodania-srodkow",
      function () {
        return require("private-next-pages/platnosc/blad-dodania-srodkow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platnosc/blad-dodania-srodkow"])
      });
    }
  